(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-maps"] && !Shopify.designMode) return;
  try {
    
  /* Parse radius options from comma-separated setting into select options */
  (function(){
    var sel = document.getElementById('radius-{{ sec_id }}');
    if (!sel) return;
    try {
      var opts = "{{ section.settings.radius_options | escape }}".split(',').map(s=>s.trim()).filter(Boolean);
      sel.innerHTML = opts.map(function(v){ return '<option value="'+v+'">'+v+' km</option>'; }).join('');
    } catch(e){}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
